<template>
	<v-card class="pv-card">
		<div class="pv-head">
			<div class="pv-head__texto">
				<span class="pv-head__eyebrow">Vista previa · asiento clonado</span>
				<h2 class="pv-head__title">{{ dataSeat.gloss || 'Sin descripción' }}</h2>
			</div>
			<div class="pv-head__acciones">
				<span class="pv-chip">{{ dataSeat.code }}</span>
				<close-icon class="cursor-pointer pv-close" @click="$emit('close')"></close-icon>
			</div>
		</div>

		<div class="pv-aviso">
			<v-icon size="15">info_outline</v-icon>
			<span>Este asiento todavía no existe. Se creará cuando presiones <strong>Guardar</strong>.</span>
		</div>

		<v-card-text class="pv-body">
			<div class="pv-datos">
				<div class="pv-dato">
					<span class="pv-dato__label">Fecha</span>
					<span class="pv-dato__valor">{{ dataSeat.date | exactDate }}</span>
				</div>
				<div class="pv-dato">
					<span class="pv-dato__label">Asiento</span>
					<span class="pv-dato__valor">{{ dataSeat.code }}</span>
				</div>
				<div class="pv-dato">
					<span class="pv-dato__label">Origen</span>
					<span class="pv-dato__valor">
						{{ dataSeat && dataSeat.typeRegister ? dataSeat.typeRegister.name : '' }}
					</span>
				</div>
				<div class="pv-dato pv-dato--ancho">
					<span class="pv-dato__label">Descripción</span>
					<span class="pv-dato__valor">{{ dataSeat.gloss }}</span>
				</div>
			</div>

			<div v-if="haySeleccion" class="pv-seleccion">
				<div class="pv-dato">
					<span class="pv-dato__label">Cta. contable</span>
					<span class="pv-dato__valor">
						{{ rowDetail.accountingAccount ? rowDetail.accountingAccount.name : '' }}
					</span>
				</div>
				<div class="pv-dato">
					<span class="pv-dato__label">Referencia</span>
					<span class="pv-dato__valor">{{ rowDetail.reference }}</span>
				</div>
			</div>

			<div v-if="openDetailSeat" class="pv-form">
				<p class="pv-form__titulo">Nuevo detalle</p>
				<v-layout row wrap align-start>
					<v-flex xs8>
						<v-layout row wrap align-end>
							<v-flex xs6 pr-2>
								<v-select
									:items="accounts"
									item-text="fullName"
									item-value="id"
									solo
									autocomplete
									hide-details
									class="filter-select shadow-inset select-autocomplete-create"
									v-model="modelDetail.accountingAccountId"
									return-object
									@input="setData">
								</v-select>
							</v-flex>
							<v-flex xs6>
								<app-input-text
									disabled
									readonly
									:text="accountingAccount.name"/>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs4 pl-2>
						<app-input-text
							model="reference"
							placeholder="Referencia"
							:text="modelDetail.reference"
							@input="setModelData"
						></app-input-text>
					</v-flex>
					<v-flex xs4 pr-2>
						<app-input-text
							model="concept"
							placeholder="Concepto"
							:text="modelDetail.concept"
							@input="setModelData"
						></app-input-text>
					</v-flex>
					<v-flex xs4>
						<autocomplete-component
							append-icon="expand_more"
							http-code="$http"
							:item="modelDetail.costCenterId"
							item-text="name"
							item-value="id"
							:items="costCenters"
							model="costCenterId"
							placeholder-value="Centro de costos"
							prop="name"
							autocomplete
							prop-search="name"
							:disabled="validCostCenter"
							:resource-url="`cost-center/${subsidiaryId}/subsidiary`"
							return-object
							select-create
							@return-data="setCostCenter"
						></autocomplete-component>
					</v-flex>
					<v-flex xs3 pl-2>
						<app-input-text
							model="amount"
							placeholder="Importe"
							:text="modelDetail.amount"
							tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
							tooltip-on-focused
							type="number"
							@input="setModelData"
						></app-input-text>
						<span
							v-if="modelDetail.amount !== 0"
							:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
							Detalle de tipo {{ typeDetail }}
						</span>
					</v-flex>
						<v-flex xs1 text-xs-center pt-2>
						<v-tooltip top>
							<button
								slot="activator"
								class="pv-add"
								type="button"
								:disabled="validFields || validInsertCostCenter"
								@click="saveNewDetailSeat">
								<v-icon size="20">add</v-icon>
							</button>
							<span v-if="validFields">Completar todos los campos</span>
							<span v-else-if="validInsertCostCenter">Debe escoger un centro de costo</span>
							<span v-else>Agregar</span>
						</v-tooltip>
					</v-flex>
				</v-layout>
			</div>

			<journal-detail-list
				class="mt-3"
				:rows="details"
				:accounts="accounts"
				:cost-centers="costCenters"
				:flagDisabledAddSeat="false"
				:created-add="true"
				:code-journal="dataSeat.code"
				:settings="settings"
				:edit-detail-inline="editDetailInline"
				@click-icon="onClickIcon"
				@on-click="rowSelected"
				@add-detail="onAddDetail"
				@get-data="setDataDetail"
			></journal-detail-list>
			<journal-detail-balance
				:balance="balance"
				:credit="credit"
				:debit="debit"
			/>
		</v-card-text>

		<div class="pv-foot">
			<span v-if="squareAmounts" class="pv-foot__nota">El asiento no está cuadrado</span>
			<button
				type="button"
				class="pv-btn pv-btn--ghost"
				@click="$emit('close')">
				Cancelar
			</button>
			<v-tooltip top>
				<button
					slot="activator"
					type="button"
					class="pv-btn pv-btn--main"
					:disabled="guardando || squareAmounts"
					@click="saveAllDetailsEdits">
					{{ guardando ? 'Guardando...' : 'Guardar y clonar' }}
				</button>
				<span v-if="squareAmounts">Debe cuadrar el asiento para guardar</span>
				<span v-else>Crea el asiento clonado</span>
			</v-tooltip>
		</div>

		<v-dialog
			v-model="alertDelete"
			max-width="390"
			persistent>
			<v-card class="pv-confirma">
				<p class="pv-confirma__titulo">¿Desea eliminar el detalle del asiento?</p>
				<div class="pv-confirma__acciones">
					<button
						type="button"
						class="pv-btn pv-btn--ghost"
						@click="closeAlertDelete">
						No
					</button>
					<button
						type="button"
						class="pv-btn pv-btn--main"
						@click="onDeleteDetail">
						Sí
					</button>
				</div>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import journalDetailBalance from '@/components/journal/journal-detail-balance';
	import journalDetailList from '@/components/journal/journal-detail-list';
	import appInputText from '@/components/autocomplete/app-input-text';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import closeIcon from '../../components/shared/icons/close.icon';

	function created() {
		this.details = this.dataSeat && this.dataSeat.details.length > 0 ? this.dataSeat.details : [];
		this.details = this.details.map((d) => {
			const cuenta = this.accounts.find(a => a.id === d.accountingAccountId) || {};
			const newD = { ...d };
			newD.codeAccounting = d.codeAccounting || cuenta.account || null;
			return newD;
		});
		this.squareAmounts = this.validateAmountActions(this.details);
	}
	function haySeleccion() {
		return !!(this.rowDetail && Object.keys(this.rowDetail).length > 0);
	}
	function formatData(value) {
		const totalDebe = value.reduce((sum, item) => sum + item.amountDebe, 0);
		const totalHaber = value.reduce((sum, item) => sum + item.amountHaber, 0);
		const details = value.map((d) => {
			const cuenta = this.accounts.find(a => a.id === d.accountingAccountId) || {};
			const newD = {};
			newD.id = null;
			newD.type = d.type;
			newD.account = d.account || null;
			newD.concept = d.concept;
			newD.reference = d.reference;
			newD.amountDebe = Number(d.amountDebe);
			newD.amountHaber = Number(d.amountHaber);
			newD.costCenterId = d.costCenterId ? d.costCenterId : null;
			newD.accountingAccountId = d.accountingAccountId;
			newD.codeAccounting = d.codeAccounting || cuenta.account || null;
			return newD;
		});
		return {
			totalDebe,
			totalHaber,
			clone: 2,
			details,
		};
	}

	function saveAllDetailsEdits() {
		this.$emit('save-clone', this.formatData(this.details));
	}


	function rowSelected(row) {
		this.rowDetail = { ...row };
		this.details = this.details.map((d) => {
			const newRow = { ...d };
			newRow.isSelected = d.id === row.id;
			return newRow;
		});
	}

	function onAddDetail() {
		this.openDetailSeat = true;
		this.editDetailInline = false;
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
	}

	function onClickIcon({ action, row, index }) {
		this.indexRowDetail = index;
		this.editDetailInline = true;
		if (action === 'new-detail-seat') {
			this.openDetailSeat = false;
			this.modelDetail = { ...row };
			this.details = this.details.map((ds, indexD) => {
				const newDataSelected = { ...ds };
				newDataSelected.onEdit = indexD === this.indexRowDetail;
				return newDataSelected;
			});
			setTimeout(() => {
				const focusDetailEdit = document.getElementById('focus-edit-inline');
				focusDetailEdit.click();
			}, 1000);
			const firstDigit = row.accountingAccount.account.charAt(0);
			this.flagValidNumberAccount = (Number(firstDigit) < 4 || Number(firstDigit) > 8);
			if (this.flagValidNumberAccount) {
				this.modelDetail.costCenterId = null;
				this.details[index].costCenter = {};
				this.details[index].costCenterId = null;
				this.details[index].flagCostCenter = false;
			}
			if (this.settings.autoCenterCost) {
				if ((Number(firstDigit) < 4) && this.details[index].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && !this.details[index].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && this.details[index].costCenterId) {
					this.flagValidCostCenter = false;
				}
			}
		} else if (action === 'delete') {
			this.alertDelete = true;
		}
	}

	function setDataDetail({ model, value, row }) {
		this.modelDetail[model] = value;
		if (model === 'reference') {
			this.details[this.indexRowDetail].reference = value;
		}
		if (model === 'concept') {
			this.details[this.indexRowDetail].concept = value;
		}
		if (model === 'amount') {
			this.details[this.indexRowDetail].amount = value;
			const type = row.type === 1 ? 'Debe' : 'Haber';
			const newValue = row.type === 1 ? Number(value) : (Number(value) * -1);
			this.details[this.indexRowDetail][`amount${type}`] = newValue;
		}
		if (model === 'accountingAccount') {
			this.modelDetail.account = value.code;
			this.modelDetail.accountingAccountId = value.id;
			this.details[this.indexRowDetail].costCenter = value.id;
			this.details[this.indexRowDetail].accountingAccount = value;
			this.details[this.indexRowDetail].accountingAccountId = value.id;
			this.details[this.indexRowDetail].account = value.code;
			const firstDigit = value.account.charAt(0);
			this.flagValidNumberAccount = (Number(firstDigit) < 4 || Number(firstDigit) > 8);
			if (this.flagValidNumberAccount) {
				this.modelDetail.costCenterId = null;
				this.details[this.indexRowDetail].costCenter = {};
				this.details[this.indexRowDetail].costCenterId = null;
				this.details[this.indexRowDetail].flagCostCenter = false;
			}
			if (this.settings.autoCenterCost) {
				if ((Number(firstDigit) < 4) && this.details[this.indexRowDetail].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && !this.details[this.indexRowDetail].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && this.details[this.indexRowDetail].costCenterId) {
					this.flagValidCostCenter = false;
				}
			}
		}
		if (model === 'costCenter') {
			this.modelDetail.costCenterId = value.id;
			this.details[this.indexRowDetail].costCenter = value;
			this.details[this.indexRowDetail].costCenterId = value.id;
			this.details[this.indexRowDetail].flagCostCenter = false;
			this.flagValidCostCenter = false;
			this.flagValidNumberAccount = true;
		}
		this.balance = this.details.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
		this.squareAmounts = this.validateAmountActions(this.details);
	}

	function validateAmountActions(array) {
		this.debit = Number(array.reduce((sum, item) => sum + item.amountDebe, 0).toFixed(2));
		this.credit = Number((array.reduce((sum, item) => sum + item.amountHaber, 0) * -1).toFixed(2));
		const credit = Number(this.credit * -1);
		this.balance = this.debit - credit;
		return this.debit > credit || this.debit < credit;
	}

	function clearModels() {
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
	}

	function closeAlertDelete() {
		this.alertDelete = false;
	}

	function onDeleteDetail() {
		this.editDetailInline = true;
		this.details.splice(this.indexRowDetail, 1);
		this.indexRowDetail = null;
		this.squareAmounts = this.validateAmountActions(this.details);
		this.closeAlertDelete();
	}

	function setCostCenter(value) {
		this.costCenter = { ...value };
		this.modelDetail.costCenterId = value.id;
	}

	function setData(value) {
		this.accountingAccount = { ...value };
		this.modelDetail.account = value.code;
		this.modelDetail.accountingAccountId = value.id;
	}

	function setModelData({ model, value }) {
		if (model === 'date' || model === 'gloss') {
			this.model[model] = value;
		} else {
			this.modelDetail[model] = value;
		}
		this.balance = this.details.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}

	async function saveNewDetailSeat() {
		const amount = Number(this.modelDetail.amount);
		const type = amount > 0 ? 'Debe' : 'Haber';
		this.modelDetail.type = amount > 0 ? 1 : 2;
		this.modelDetail.status = 1;
		this.modelDetail[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
		const otherType = type === 'Debe' ? 'Haber' : 'Debe';
		this.modelDetail[`amount${otherType}`] = 0;
		this.details.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			costCenter: this.costCenter,
		});
		this.openDetailSeat = false;
		this.squareAmounts = this.validateAmountActions(this.details);
	}

	function validFields() {
		return !this.modelDetail.account || !this.modelDetail.accountingAccountId
		|| !this.modelDetail.amount	|| !this.modelDetail.concept
		|| !this.modelDetail.reference;
	}

	function validCostCenter() {
		let valid = false;
		if (this.modelDetail.account !== null) {
			const firstDigit = this.modelDetail.account.charAt(0);
			valid = (Number(firstDigit) < 4 && Number(firstDigit) > 8);
		}
		if (valid) {
			this.setCostCenter({});
		}
		return valid;
	}
	function validInsertCostCenter() {
		let valid = false;
		if (this.settings.autoCenterCost) {
			const firstDigit = this.modelDetail.account.charAt(0);
			if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
				valid = true;
			}
		}
		return valid;
	}

	function typeDetail() {
		return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
	}

	function data() {
		return {
			details: [],
			rowDetail: {},
			openDetailSeat: false,
			indexRowDetail: null,
			editDetailInline: false,
			flagValidNumberAccount: false,
			flagValidCostCenter: false,
			flagSquareSeats: false,
			modelDetail: {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: 0,
			},
			credit: null,
			debit: null,
			balance: null,
			isLoading: false,
			squareAmounts: false,
			alertDelete: false,
			costCenter: {},
			accountingAccount: {},
		};
	}

	export default {
		name: 'preview-clone-seat',
		data,
		created,
		components: {
			closeIcon,
			journalDetailList,
			journalDetailBalance,
			appInputText,
			autocompleteComponent,
		},
		methods: {
			rowSelected,
			onAddDetail,
			onClickIcon,
			setDataDetail,
			validateAmountActions,
			saveAllDetailsEdits,
			formatData,
			clearModels,
			closeAlertDelete,
			onDeleteDetail,
			setCostCenter,
			setData,
			setModelData,
			saveNewDetailSeat,
		},
		computed: {
			validFields,
			haySeleccion,
			validCostCenter,
			validInsertCostCenter,
			typeDetail,
		},
		props: {
			guardando: {
				type: Boolean,
				default: false,
			},
			subsidiaryId: [Number, String],
			dataSeat: {
				type: Object,
				default: () => ({}),
			},
			settings: {
				type: Object,
				default: () => ({}),
			},
			accounts: {
				default: () => [],
				type: Array,
			},
			costCenters: {
				default: () => [],
				type: Array,
			},
			modules: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>
<style lang="scss" scoped>
$pv-ink: #16222b;
$pv-ink-2: #5b6b76;
$pv-line: #e3e9ec;
$pv-plane: #f4f7f8;
$pv-teal: #02979b;
$pv-teal-dark: #017e82;
$pv-red: #e5484d;

.pv-card {
	border-radius: 14px !important;
	overflow: hidden;
}

.pv-head {
	align-items: center;
	background: linear-gradient(135deg, $pv-teal 0%, $pv-teal-dark 100%);
	display: flex;
	justify-content: space-between;
	padding: 14px 18px;
}

.pv-head__eyebrow {
	color: rgba(255, 255, 255, 0.78);
	display: block;
	font-size: 9.5px;
	font-weight: 700;
	letter-spacing: 1px;
	text-transform: uppercase;
}

.pv-head__title {
	color: #ffffff;
	font-size: 16px;
	font-weight: 700;
	line-height: 1.3;
	margin: 3px 0 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.pv-head__acciones {
	align-items: center;
	display: flex;
	flex: 0 0 auto;
	gap: 12px;
	margin-left: 16px;
}

.pv-chip {
	background: rgba(255, 255, 255, 0.18);
	border: 1px solid rgba(255, 255, 255, 0.28);
	border-radius: 999px;
	color: #ffffff;
	font-size: 11.5px;
	font-weight: 700;
	padding: 4px 12px;
	white-space: nowrap;
}

.pv-close {
	opacity: 0.9;

	&:hover {
		opacity: 1;
	}
}

.pv-aviso {
	align-items: center;
	background: #fff8e6;
	border-bottom: 1px solid #f2e3bd;
	color: #8a6a12;
	display: flex;
	font-size: 12px;
	gap: 8px;
	padding: 9px 18px;

	.v-icon {
		color: #c79a21 !important;
	}
}

.pv-body {
	padding: 16px 18px 10px !important;
}

.pv-datos {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.pv-dato {
	background: $pv-plane;
	border: 1px solid $pv-line;
	border-radius: 10px;
	flex: 1 1 150px;
	min-width: 0;
	padding: 9px 12px;
}

.pv-dato--ancho {
	flex: 1 1 100%;
}

.pv-dato__label {
	color: $pv-ink-2;
	display: block;
	font-size: 9.5px;
	font-weight: 700;
	letter-spacing: 0.9px;
	text-transform: uppercase;
}

.pv-dato__valor {
	color: $pv-ink;
	display: block;
	font-size: 13px;
	font-weight: 600;
	margin-top: 2px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.pv-seleccion {
	background: rgba(2, 151, 155, 0.06);
	border: 1px solid rgba(2, 151, 155, 0.22);
	border-radius: 10px;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 10px;
	padding: 8px;

	.pv-dato {
		background: #ffffff;
	}
}

.pv-form {
	background: #ffffff;
	border: 1px solid $pv-line;
	border-radius: 10px;
	margin-top: 12px;
	padding: 10px 12px;
}

.pv-form__titulo {
	color: $pv-ink-2;
	font-size: 9.5px;
	font-weight: 700;
	letter-spacing: 0.9px;
	margin-bottom: 6px;
	text-transform: uppercase;
}

.pv-foot {
	align-items: center;
	background: $pv-plane;
	border-top: 1px solid $pv-line;
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	padding: 12px 18px;
}

.pv-foot__nota {
	color: $pv-red;
	font-size: 11.5px;
	font-weight: 600;
	margin-right: auto;
}

.pv-btn {
	border-radius: 8px;
	font-size: 12.5px;
	font-weight: 700;
	height: 34px;
	min-width: 104px;
	padding: 0 18px;
	transition: background-color 0.18s ease;
}

.pv-btn--ghost {
	background: #ffffff;
	border: 1px solid $pv-line;
	color: $pv-ink-2;

	&:hover {
		background: $pv-plane;
	}
}

.pv-btn--main {
	background: $pv-teal;
	border: none;
	color: #ffffff;

	&:hover {
		background: $pv-teal-dark;
	}

	&:disabled {
		background: #b9c6cc;
		cursor: not-allowed;
	}
}

.pv-confirma {
	border-radius: 12px !important;
	padding: 20px;
	text-align: center;
}

.pv-confirma__titulo {
	color: $pv-ink;
	font-size: 15px;
	font-weight: 700;
	margin-bottom: 16px;
}

.pv-confirma__acciones {
	display: flex;
	gap: 10px;
	justify-content: center;
}

.cursor-pointer {
	cursor: pointer;
}

@media (max-width: 768px) {
	.pv-head__title {
		font-size: 14px;
	}

	.pv-dato {
		flex: 1 1 100%;
	}
}
.pv-add {
	align-items: center;
	background: $pv-teal;
	border: none;
	border-radius: 50%;
	box-shadow: 0 2px 6px rgba(2, 151, 155, 0.35);
	color: #ffffff;
	display: inline-flex;
	height: 34px;
	justify-content: center;
	padding: 0;
	transition: background-color 0.18s ease;
	width: 34px;

	.v-icon {
		color: #ffffff !important;
		font-size: 20px !important;
	}

	&:hover {
		background: $pv-teal-dark;
	}

	&:disabled {
		background: #cfd8dd;
		box-shadow: none;
		cursor: not-allowed;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/journal/preview-clone-seat.vue